module.exports = __webpack_public_path__ + "img/sj.1e78d8e7.svg";